module.exports = __webpack_public_path__ + "static/thermal_small-ef80bacf81c7eb20855ee366474b1438.jpg";